import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import blogService from "../services/blog-services";
import { handleErrors } from "../utils/errorHandler";
import { faWhatsappSquare } from "@fortawesome/free-brands-svg-icons";

const BlogInner = () => {
  const dataUrl = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [blogData, setBlogData] = useState({});
  const [BlogId, setBlogId] = useState();
  const [BlogUrl, setBlogUrl] = useState();
  const pathname = dataUrl.slug;
  const lastSegment = pathname.split("-");
  const extractId = lastSegment.pop();

  const extractUrl = lastSegment.join("-");
  const fetchBlogDetail = useCallback(async () => {
    const payload = {
      blogId: extractId,
      blogURL: extractUrl,
    };

    setLoading(true);
    try {
      const response = await blogService.getBlogDetail(payload);
      setBlogData(response.data.result);
    } catch (error) {
      const errorMessage = handleErrors(error);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [BlogId, BlogUrl]);

  useEffect(() => {
    fetchBlogDetail();
  }, [fetchBlogDetail, dataUrl]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <section className="blog-inner">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-9 mx-auto">
            <div className="blog-content">
              <div className="blog-title">
                <h1>{blogData.blogName}</h1>
              </div>
              <div className="blog-meta-wrap">
                <div>
                  <div className="meta-details">
                    <div className="icon">
                      <FontAwesomeIcon icon={faUser} />
                    </div>
                    <div className="user-info">
                      <p>By Curenza</p>
                      <span>{formatDate(blogData.postedOn)}</span>
                    </div>
                  </div>
                  <div className="blog-category-wrap">
                    <ul>
                      {blogData.blogCategory &&
                        blogData.blogCategory
                          .split(",")
                          .map((category, index) => (
                            <li key={index}>{category.trim()}</li>
                          ))}
                    </ul>
                  </div>
                </div>
                <div className="blog-share-option">
                  <div className="optionitem">
                    <Link
                      to={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                        window.location.href
                      )}`}
                      target="_blank"
                    >
                      <FontAwesomeIcon icon={faWhatsappSquare} />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="feature-image">
                <img src={blogData.bigImage} alt="img" />
              </div>
              <div className="html-content">
                <div
                  className="blog-content-inner"
                  dangerouslySetInnerHTML={{
                    __html: blogData.blogDesc,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogInner;
